import { useRef, useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";

function AccordionItem({ children, header, on, onActive }) {
  const [active, setActive] = useState(on || false);
  const contentRef = useRef();

  useEffect(() => {}, [active]);

  return (
    <div className="accordion">
      <header
        className="header"
        onClick={() => {
          setActive((prev) => !prev);
          if (onActive) {
            onActive(!active);
          }
        }}
      >
        <div>
          <span>{header}</span>
          {active ? <Icon name="chevron up" /> : <Icon name="chevron down" />}
          <span>{children.label}</span>
        </div>
      </header>
      {active ? (
        <div
          className="accordionItem"
          ref={contentRef}
          style={{ display: active ? "block" : "none" }}
        >
          {children}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default AccordionItem;
